import {
  AlertTriangle,
  Save,
  X,
} from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useUIStore } from "@/store/uiStore";
import { useNavigate } from "react-router-dom";

export function NavigationConfirmModal() {
  const { 
    modals, 
    navigationLock, 
    closeModal, 
    cancelNavigation 
  } = useUIStore();
  const navigate = useNavigate();

  const isOpen = modals.navigationConfirm;
  const lockReason = navigationLock.lockReason || "You have unsaved changes";

  const handleConfirm = () => {
    const pendingNav = navigationLock.pendingNavigation;
    
    // Unlock navigation first
    useUIStore.setState((state) => ({
      navigationLock: {
        isLocked: false,
        lockReason: undefined,
        pendingNavigation: undefined
      },
      modals: {
        ...state.modals,
        navigationConfirm: false
      }
    }));
    
    // Handle URL-based navigation
    if (pendingNav?.path !== undefined) {
      if (typeof pendingNav.path === 'string') {
        navigate(pendingNav.path, {
          replace: pendingNav.options?.replace,
          state: pendingNav.options?.state
        });
      } else if (typeof pendingNav.path === 'number') {
        navigate(pendingNav.path);
      }
    }
  };

  const handleCancel = () => {
    cancelNavigation();
  };

  const handleClose = () => {
    closeModal("navigationConfirm");
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <DialogTitle>Unsaved Changes</DialogTitle>
          </div>
          <DialogDescription>
            {lockReason}. Are you sure you want to leave? Your changes will be lost.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:justify-end">
          <Button
            variant="outline"
            onClick={handleCancel}
            className="flex items-center gap-2"
          >
            <X className="h-4 w-4" />
            Stay Here
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            className="flex items-center gap-2"
          >
            <Save className="h-4 w-4" />
            Leave Anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
